<section class="admin-properties">
    <header class="row page-header">
        <div class="col-sm-6">
            <h2 class="title">PROPERTIES</h2>
        </div>
    </header>

    <main>
        <sp-admin-property-list
            [propertySearchResult]="propertySearchResult$ | async"
            [propertyTypes]="propertyTypes$ | async"
            [propertyFilterSettings]="propertyFilterSettings$ | async"
            [loggedInUserProfile]="loggedInUserProfile$ | async"
            (clearCache)="onClearCache($event)"
            (filterChanged)="onFilterChanged($event)"            
            (deactivate)="onDeactivateProperty($event)"
            (reactivate)="onReactivateProperty($event)"
            (reassign)="onReassignProperty($event)"
            (duplicate)="onDuplicateProperty($event)">
        </sp-admin-property-list>
    </main>
</section>
